<template>
  <div>
    <vs-card style="margin-bottom: 25px">
      <vs-card>
        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          :title="null"
          :subtitle="null"
          finishButtonText="Tamam"
          @on-complete="formSubmitted"
          nextButtonText="Sonraki"
          backButtonText="Önceki"
        >
          <tab-content title="Genel" class="mb-5" icon="feather icon-map">
            <!-- tab 1 content -->
            <form data-vv-scope="step-1">
              <b-row style="margin-bottom: 10px">
                <b-col cols="6">
                  <b-row style="margin-bottom: 10px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        label="Firma Adı"
                        label-for="h-first-name"
                        style="font-size: 14px"
                      >
                      </b-form-group>
                    </b-col>

                    <b-col cols="8">
                      <vue-autosuggest
                        v-model="query"
                        style="width: 100%"
                        :suggestions="filteredOptions"
                        :get-suggestion-value="getSuggestionValue"
                        :input-props="{
                          id: 'autosuggest__input',
                          class: 'form-control',
                          placeholder: 'Cari Adı',
                        }"
                        @input="onInputChange"
                      >
                        <template slot-scope="{ suggestion }">
                          <div
                            class="d-flex align-items-center my-suggestion-item"
                          >
                            <div class="detail ml-50 my-suggestion-item">
                              <b-card-text class="mb-0">
                                {{ suggestion.item.ACTNAME }}
                              </b-card-text>
                            </div>
                          </div>
                        </template>
                      </vue-autosuggest>
                    </b-col>
                  </b-row>
                  <b-row style="margin-bottom: 10px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        label="Tarih"
                        label-for="h-first-name"
                        style="font-size: 14px"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <b-form-datepicker
                        v-model="istenenTarih"
                        :placeholder="getNow()"
                        local="en"
                        class="mb-2"
                        today-variant="danger"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      />
                    </b-col>
                  </b-row>
                  <b-row style="margin-bottom: 10px">
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        label="Fiş No"
                        label-for="h-first-name"
                        style="font-size: 14px"
                      >
                      </b-form-group>
                    </b-col>

                    <b-col cols="8" v-if="degerKontrol === true">
                      <b-form-input
                        :disabled="true"
                        id="h-first-name"
                        v-model="fisNo"
                      />
                    </b-col>
                    <b-col cols="8" v-else>
                      <b-form-input id="h-first-name" v-model="fisNo" />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <b-row>
                    <b-col lg="2" sm="3" align-self="center">
                      <b-form-group
                        label="Grup Kodu"
                        label-for="h-first-name"
                        style="font-size: 14px"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col lg="4" sm="9">
                      <v-select
                        :color="select2"
                        v-model="grupkodSecilen"
                        :options="grupkod"
                        class="select-size-sm"
                        style="
                          max-height: 30px !important;
                          border-top-right-radius: 0;
                          border-bottom-right-radius: 0;
                        "
                        autocomplete
                        ref="selectElement"
                      >
                      </v-select>
                    </b-col>
                    <b-col lg="2" sm="3" align-self="center">
                      <b-form-group
                        label="Teslim Alan"
                        label-for="h-first-name"
                        style="font-size: 14px"
                      >
                      </b-form-group>
                    </b-col>

                    <b-col lg="4" sm="9">
                      <b-form-input id="h-first-name" v-model="teslimAlan" />
                    </b-col>
                  </b-row>
                  <b-row style="margin-top: 15px">
                    <b-col lg="2" sm="3" align-self="center">
                      <b-form-group label="Açıklama" style="font-size: 14px">
                      </b-form-group>
                    </b-col>
                    <b-col lg="10" sm="9">
                      <vs-textarea label="Açıklama" v-model="textareaNot" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </tab-content>

          <!-- tab 2 content -->
          <tab-content
            title="Fatura"
            class="mb-5"
            icon="feather icon-file-text"
          >
            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Fatura Adı"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVNAME" />
              </b-col>
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Ülke"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVCOUNTRY" />
              </b-col>
            </b-row>

            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Şehir"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVCITY" />
              </b-col>
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Mahalle"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVTOWN" />
              </b-col>
            </b-row>

            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Mail"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVEMAIL" />
              </b-col>
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Telefon"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVGSM" />
              </b-col>
            </b-row>

            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Fatura Adresi"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="INVADRES" />
              </b-col>
            </b-row>
          </tab-content>

          <!-- tab 3 content -->
          <tab-content title="Teslimat" class="mb-5" icon="feather icon-truck">
            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Teslimat Adı"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDNAME" />
              </b-col>
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Ülke"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDCOUNTRY" />
              </b-col>
            </b-row>

            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Şehir"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDCITY" />
              </b-col>
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Mahalle"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDTOWN" />
              </b-col>
            </b-row>

            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Mail"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDEMAIL" />
              </b-col>
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Telefon"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDGSM" />
              </b-col>
            </b-row>
            <b-row style="margin-bottom: 10px">
              <b-col cols="2" align-self="center">
                <b-form-group
                  label="Fatura Adresi"
                  label-for="h-first-name"
                  style="font-size: 14px"
                >
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-input id="h-first-name" v-model="SENDADRES" />
              </b-col>
              <b-col>
                <vs-checkbox v-model="checkBox1" @change="adresKontrol"
                  >Fatura bilgilerim ile teslimat bilgilerim aynı</vs-checkbox
                >
              </b-col>
            </b-row>
          </tab-content>
        </form-wizard>
      </vs-card>
    </vs-card>
    <vs-card v-if="isMobile()">
      <div v-if="genelDisabled == false">
        <div class="demo-inline-spacing">
          <b-form ref="form" @submit.prevent="repeateAgain">
            <b-row>
              <b-col cols="12">
                <b-button
                  variant="primary"
                  @click="repeateAgain"
                  style="padding: 0; width: inherit; margin-bottom: 15px"
                >
                  <feather-icon icon="PlusIcon" class="mr-25" />
                  Ekle
                </b-button>
              </b-col>
              <b-col cols="12"> </b-col>

              <b-col cols="12">
                <b-row>
                  <b-col cols="4">
                    <p style="text-align: center">Stok</p>
                  </b-col>
                  <b-col cols="3">
                    <p style="text-align: center">Birimi</p>
                  </b-col>

                  <b-col cols="4">
                    <p style="text-align: center">Parti No</p>
                  </b-col>

                  <b-col cols="1"> </b-col>
                </b-row>
              </b-col>

              <b-col cols="12">
                <b-row
                  v-for="(item, index) in items"
                  :id="item.id"
                  :key="item.id"
                  ref="row"
                >
                  <!-- Item Name -->
                  <b-col
                    cols="4"
                    style="padding-right: 0; margin-bottom: 10px"
                    v-if="item.disable == false"
                  >
                    <vue-autosuggest
                      v-model="item.querystok"
                      style="width: 100%"
                      :suggestions="filteredOptionsstok"
                      :get-suggestion-value="getSuggestionValuestok"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Stok Kodu / Stok Adı',
                      }"
                      @input="onInputChangestok"
                    >
                      <template slot-scope="{ suggestion }">
                        <div
                          class="d-flex align-items-center my-suggestion-item"
                        >
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.STOCKNO }} /
                              {{ suggestion.item.STOCKNAME }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-col>

                  <b-col
                    cols="4"
                    style="padding-right: 0; margin-bottom: 10px"
                    v-else
                  >
                    <vue-autosuggest
                      v-model="item.querystok"
                      style="width: 100%"
                      :suggestions="filteredOptionsstok"
                      :get-suggestion-value="getSuggestionValuestok"
                      :input-props="{
                        disabled: true,
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Stok Kodu / Stok Adı',
                      }"
                      @input="onInputChangestok"
                    >
                      <template slot-scope="{ suggestion }">
                        <div
                          class="d-flex align-items-center my-suggestion-item"
                        >
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.STOCKNO }} /
                              {{ suggestion.item.STOCKNAME }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-col>
                  <b-col cols="3" style="padding-right: 0; margin-bottom: 10px">
                    <b-form-group label-for="quantity">
                      <b-form-input
                        :disabled="true"
                        v-model="item.stokbirim"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Birim"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Quantity -->

                  <b-col
                    cols="4"
                    style="padding-right: 0; margin-bottom: 10px"
                    v-if="item.disable == false"
                  >
                    <b-form-group label-for="price">
                      <b-input-group>
                        <b-input-group-prepend
                          v-if="item.partinoDisabled == false"
                        >
                          <feather-icon
                            style="color: #7367f0"
                            icon="PlusIcon"
                            @click="partinoOlustur(index)"
                          />
                        </b-input-group-prepend>

                        <b-input-group-prepend v-else>
                          <feather-icon disabled icon="PlusIcon" />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="item.partino"
                          style="font-size: inherit"
                          id="quantity"
                          type="text"
                          placeholder="Parti No"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="4"
                    style="padding-right: 0; margin-bottom: 10px"
                    v-else
                  >
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.partino"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Parti No"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="4"
                    style="padding-right: 0"
                    v-if="item.disable == false"
                  >
                    <b-form-group label-for="price">
                      <b-input-group>
                        <b-input-group-prepend
                          is-text
                          v-if="item.miktar1Disabled == false"
                        >
                          <feather-icon
                            style="color: #7367f0"
                            icon="InboxIcon"
                            @click="kantarCek(index)"
                          />
                        </b-input-group-prepend>
                        <b-input-group-prepend
                          style="display: flex"
                          is-text
                          v-else
                        >
                          <feather-icon
                            icon="InboxIcon"
                            @click="kantarCek(index)"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="item.miktar1"
                          style="font-size: inherit"
                          id="quantity"
                          type="text"
                          placeholder="Miktar 1"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.miktar1"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Miktar 1"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="3"
                    style="padding-right: 0"
                    v-if="item.disable == false"
                  >
                    <b-form-group label-for="price">
                      <b-input-group>
                        <b-input-group-prepend
                          is-text
                          v-if="item.miktar2Disabled == false"
                        >
                          <feather-icon
                            style="color: #7367f0"
                            icon="InboxIcon"
                            @click="kantar2Cek(index)"
                          />
                        </b-input-group-prepend>
                        <b-input-group-prepend
                          style="display: flex"
                          is-text
                          v-else
                        >
                          <feather-icon
                            icon="InboxIcon"
                            @click="kantar2Cek(index)"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="item.miktar2"
                          style="font-size: inherit"
                          id="quantity"
                          type="text"
                          placeholder="Miktar 2"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.miktar2"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Miktar 2"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="3"
                    style="padding-right: 0"
                    v-if="item.disable == false"
                  >
                    <b-form-group label-for="price">
                      <b-form-input
                        v-model="item.fiyat"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Fiyat"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.fiyat"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Fiyat"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    style="padding-right: 0; margin-left: 10px"
                    cols="1"
                    class="mb-50"
                  >
                    <b-row style="padding: 0">
                      <b-col style="padding: 0" v-if="item.disable == false">
                        <feather-icon
                          icon="CheckIcon"
                          class="cursor-pointer"
                          svgClasses="w-7 h-7"
                          style="color: green"
                          @click="addItem(index)"
                        />
                      </b-col>
                      <b-col style="padding: 0" v-else>
                        <b-button
                          style="padding: 0"
                          variant="flat-success"
                          class="btn-icon rounded-circle"
                          disabled
                        >
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                      </b-col>
                      <b-col style="padding: 0">
                        <feather-icon
                          @click="removeItem(index)"
                          icon="TrashIcon"
                          class="cursor-pointer"
                          svgClasses="w-6 h-6"
                          style="color: red"
                        />
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- Remove Button -->

                  <b-col cols="12" style="height: 5px"> </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- Row Loop -->
          </b-form>
        </div>
        <div slot="footer" style="margin-top: 100px">
          <vs-row vs-justify="flex-end">
            <vs-button
              style="background-color: #0d6efd !important"
              type="gradient"
              color="success"
              icon="save"
              @click="islemiTamamla()"
              >İşlemi Tamamla</vs-button
            >
          </vs-row>
        </div>
      </div>
    </vs-card>
    <vs-card v-else>
      <div v-if="genelDisabled == false">
        <div class="demo-inline-spacing">
          <b-form ref="form" @submit.prevent="repeateAgain">
            <b-row>
              <b-col cols="12"> </b-col>

              <b-col cols="12">
                <b-row>
                  <b-col cols="3">
                    <p style="text-align: center">Stok</p>
                  </b-col>
                  <b-col cols="1">
                    <p style="text-align: center">Birimi</p>
                  </b-col>

                  <b-col cols="3">
                    <p style="text-align: center">Parti No</p>
                  </b-col>
                  <b-col cols="1">
                    <p style="text-align: center">Miktar 1</p>
                  </b-col>
                  <b-col cols="1">
                    <p style="text-align: center">Miktar 2</p>
                  </b-col>
                  <b-col cols="2">
                    <p style="text-align: center">Fiyat</p>
                  </b-col>

                  <b-col cols="1"> </b-col>
                </b-row>
              </b-col>

              <b-col cols="12">
                <b-row
                  v-for="(item, index) in items"
                  :id="item.id"
                  :key="item.id"
                  ref="row"
                >
                  <!-- Item Name -->
                  <b-col
                    cols="5"
                    style="padding-right: 0; margin-bottom: 10px"
                    v-if="item.disable == false"
                  >
                    <vue-autosuggest
                      v-model="item.querystok"
                      style="width: 100%"
                      :suggestions="filteredOptionsstok"
                      :get-suggestion-value="getSuggestionValuestok"
                      :input-props="{
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Stok Kodu / Stok Adı',
                      }"
                      @input="onInputChangestok"
                    >
                      <template slot-scope="{ suggestion }">
                        <div
                          class="d-flex align-items-center my-suggestion-item"
                        >
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.STOCKNO }} /
                              {{ suggestion.item.STOCKNAME }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-col>

                  <b-col cols="3" style="padding-right: 0" v-else>
                    <vue-autosuggest
                      v-model="item.querystok"
                      style="width: 100%"
                      :suggestions="filteredOptionsstok"
                      :get-suggestion-value="getSuggestionValuestok"
                      :input-props="{
                        disabled: true,
                        id: 'autosuggest__input',
                        class: 'form-control',
                        placeholder: 'Stok Kodu / Stok Adı',
                      }"
                      @input="onInputChangestok"
                    >
                      <template slot-scope="{ suggestion }">
                        <div
                          class="d-flex align-items-center my-suggestion-item"
                        >
                          <div class="detail ml-50 my-suggestion-item">
                            <b-card-text class="mb-0">
                              {{ suggestion.item.STOCKNO }} /
                              {{ suggestion.item.STOCKNAME }}
                            </b-card-text>
                          </div>
                        </div>
                      </template>
                    </vue-autosuggest>
                  </b-col>
                  <b-col cols="1" style="padding-right: 0">
                    <b-form-group label-for="quantity">
                      <b-form-input
                        :disabled="true"
                        v-model="item.stokbirim"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Birim"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Quantity -->

                  <b-col cols="6" v-if="item.disable == false">
                    <b-form-group label-for="price">
                      <b-input-group>
                        <b-input-group-prepend
                          is-text
                          style="display: flex"
                          v-if="item.partinoDisabled == false"
                        >
                          <feather-icon
                            style="color: #7367f0"
                            icon="PlusIcon"
                            @click="partinoOlustur(index)"
                          />
                        </b-input-group-prepend>
                        <b-input-group-prepend is-text v-else>
                          <feather-icon disabled icon="PlusIcon" />
                        </b-input-group-prepend>

                        <b-form-input
                          v-model="item.partino"
                          id="quantity"
                          type="text"
                          placeholder="Parti No"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.partino"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Parti No"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="5"
                    style="padding-right: 0"
                    v-if="item.disable == false"
                  >
                    <b-input-group>
                      <b-input-group-prepend
                        is-text
                        style="display: flex"
                        v-if="item.miktar1Disabled == false"
                      >
                        <feather-icon
                          style="color: #7367f0"
                          icon="InboxIcon"
                          @click="kantarCek(index)"
                        />
                      </b-input-group-prepend>
                      <b-input-group-prepend
                        style="display: flex"
                        is-text
                        v-else
                      >
                        <feather-icon
                          icon="InboxIcon"
                          @click="kantarCek(index)"
                        />
                      </b-input-group-prepend>
                      <b-form-input
                        v-model="item.miktar1"
                        id="quantity"
                        type="text"
                        placeholder="Miktar 1"
                      />
                    </b-input-group>
                  </b-col>
                  <b-col cols="1" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.miktar1"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Miktar 1"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    cols="3"
                    style="padding-right: 0"
                    v-if="item.disable == false"
                  >
                    <b-form-group label-for="price">
                      <b-input-group>
                        <b-input-group-prepend
                          is-text
                          style="display: flex"
                          v-if="item.miktar2Disabled == false"
                        >
                          <feather-icon
                            style="color: #7367f0"
                            icon="InboxIcon"
                            @click="kantar2Cek(index)"
                          />
                        </b-input-group-prepend>
                        <b-input-group-prepend
                          style="display: flex"
                          is-text
                          v-else
                        >
                          <feather-icon
                            icon="InboxIcon"
                            @click="kantar2Cek(index)"
                          />
                        </b-input-group-prepend>
                        <b-form-input
                          v-model="item.miktar2"
                          id="quantity"
                          type="text"
                          placeholder="Miktar 2"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="1" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.miktar2"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Miktar 2"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="4" v-if="item.disable == false">
                    <b-form-group label-for="price">
                      <b-form-input
                        v-model="item.fiyat"
                        id="quantity"
                        type="text"
                        placeholder="Fiyat"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" style="padding-right: 0" v-else>
                    <b-form-group label-for="price">
                      <b-form-input
                        :disabled="true"
                        v-model="item.fiyat"
                        style="font-size: inherit"
                        id="quantity"
                        type="text"
                        placeholder="Fiyat"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col
                    style="padding-left: 25px"
                    cols="12"
                    class="mb-50"
                    v-if="item.disable == false"
                  >
                    <b-row align-h="end" style="margin-top: 20px">
                      <b-col col lg="2">
                        <vs-button
                          style="border-radius: 5px"
                          type="gradient"
                          icon="done"
                          class="w-full"
                          @click="addItem(index)"
                          >Ekle</vs-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    style="padding-right: 0; padding-left: 25px"
                    cols="1"
                    class="mb-50"
                    v-else
                  >
                    <b-row style="padding: 0">
                      <b-col style="padding: 0">
                        <b-button
                          style="padding: 0"
                          variant="flat-success"
                          class="btn-icon rounded-circle"
                          disabled
                        >
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                      </b-col>
                      <b-col style="padding: 0">
                        <feather-icon
                          @click="removeItem(index)"
                          icon="TrashIcon"
                          class="cursor-pointer"
                          svgClasses="w-6 h-6"
                          style="color: red"
                        />
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- Remove Button -->

                  <b-col cols="12" style="height: 5px"> </b-col>
                  <b-col cols="12">
                    <hr />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- Row Loop -->
          </b-form>
        </div>
        <div slot="footer" style="margin-top: 100px">
          <vs-row vs-justify="flex-end">
            <vs-button
              style="background-color: #0d6efd !important"
              type="gradient"
              color="success"
              icon="save"
              @click="islemiTamamla()"
              >İşlemi Tamamla</vs-button
            >
          </vs-row>
        </div>
      </div>
    </vs-card>
    <vs-card v-if="degerKontrol != 'true'">
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Store from "../../store/store";
import state from "../../store/state";
//import SatinalmaPageButon from "../components/kralincir-components/SatinalmaPageButon.vue";
import { isMobile } from "mobile-device-detect";
//import userJson from "../../../public/user.json";
import { Validator } from "vee-validate";
import {
  BButton,
  BModal,
  VBModal,
  BFormDatepicker,
  BTabs,
  BTab,
  BFormSelect,
  BCardText,
} from "bootstrap-vue";
//import { uuid } from "vue-uuid";
import moment from "moment";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
const dict = {
  custom: {
    first_name: {
      required: "First name is required",
      alpha: "First name may only contain alphabetic characters",
    },
    last_name: {
      required: "Last name is required",
      alpha: "Last name may only contain alphabetic characters",
    },
    email: {
      required: "Email is required",
      email: "Please enter valid email",
    },
    job_title: {
      required: "Job title name is required",
      alpha: "Job title may only contain alphabetic characters",
    },
    proposal_title: {
      required: "Proposal title name is required",
      alpha: "Proposal title may only contain alphabetic characters",
    },
    event_name: {
      required: "Event name is required",
      alpha: "Event name may only contain alphabetic characters",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
export default {
  data() {
    return {
      adresKontrolDurum: false,
      SENDNAME: "",
      SENDCOUNTRY: "",
      SENDCITY: "",
      SENDTOWN: "",
      SENDADRES: "",
      SENDEMAIL: "",
      SENDGSM: "",

      INVNAME: "",
      INVCOUNTRY: "",
      INVCITY: "",
      INVTOWN: "",
      INVADRES: "",
      INVEMAIL: "",
      INVGSM: "",

      checkBox1: false,
      genelDisabled: false,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      dir: false,
      //  guidid: uuid.v4(),
      //  uuid: uuid.v1(),
      degerKontrol: false,
      fiyat: "",
      miktar2: "",
      miktar1: "",
      stokbirim: "",
      firmaAd: "",
      grupKod: "",
      textareaNot: "",
      select2: "primary",
      grupkod: ["İhracat", "Özel Sipariş", "Yurtiçi"],
      grupkodSecilen: "",
      teslimAlan: "",
      istenenTarih: "",
      fisNo: "",
      query: "",
      filteredOptions: [],
      ACTNAME: "",
      ACTID: "",
      querystok: "",
      filteredOptionsstok: [],
      stokList: [],
      stokIdSecilen: "",
      gelenFis: [],
      rowData: [],

      items: [
        {
          id: 1,
          querystok: "",
          query: "",
          stokbirim: "",
          partino: "",
          miktar1: "",
          miktar2: "",
          disable: false,
          fiyat: "",
          partinoDisabled: false,
          miktar1Disabled: false,
          miktar2Disabled: false,
        },
      ],
      formattedPartino: "",
      cloneQuestions: [],

      itemsIndex: 0,
      nextTodoId: 2,
    };
  },
  components: {
    FormWizard,
    TabContent,
    // SatinalmaPageButon,
    AgGridVue,
    BFormSelect,
    BTabs,
    "v-select": vSelect,
    BFormDatepicker,
    BTab,
  },
  methods: {
    formSubmitted() {
      var vs = this.$vs;
      vs.notify({
        title: "Başarılı",
        text: "Detay bilgileri alındı .",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        position: "top-center",
      });
      this.adresKontrolDurum = true;
    },

    adresKontrol() {
      if (this.checkBox1 == true) {
        this.SENDNAME = this.INVNAME;
        this.SENDCOUNTRY = this.INVCOUNTRY;
        this.SENDCITY = this.INVCITY;
        this.SENDTOWN = this.INVTOWN;
        this.SENDADRES = this.INVADRES;
        this.SENDEMAIL = this.INVEMAIL;
        this.SENDGSM = this.INVGSM;
      } else {
        this.SENDNAME = "";
        this.SENDCOUNTRY = "";
        this.SENDCITY = "";
        this.SENDTOWN = "";
        this.SENDADRES = "";
        this.SENDEMAIL = "";
        this.SENDGSM = "";
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    kantar2Cek(index) {
      var vm = this;
      const soap = require("soap");
      const url = userJson.kantarPC;
      const args = {};
      soap.createClient(url, function (err, client) {
        client.terazioku(args, function (err, result) {
          if (result.teraziokuResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.teraziokuResult);
            vm.items[index].miktar2 = vm.veriler;
            vm.items[index].miktar2Disabled = true;
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    kantarCek(index) {
      var vm = this;
      const soap = require("soap");
      const url = userJson.kantarPC;
      const args = {};
      soap.createClient(url, function (err, client) {
        client.terazioku(args, function (err, result) {
          if (result.teraziokuResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.teraziokuResult);
            vm.items[index].miktar1 = vm.veriler;
            vm.items[index].miktar1Disabled = true;
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    isMobile: function () {
      return isMobile;
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    partiOlustur(index) {
      const today = new Date();
      this.formattedPartino = moment(String(today)).format("yyyyMMDDhhmmss");
      //  this.partino = this.formattedPartino;
      this.items[index].partino = this.formattedPartino;

      if (this.items[index].partino != "") return true;
      else return false;
    },
    partinoOlustur(index) {
      var vs = this.$vs;
      const today = new Date();
      this.formattedPartino = moment(String(today)).format("yyyyMMDDhhmmss");
      this.items[index].partino = this.formattedPartino;
      this.items[index].partinoDisabled = true;
      vs.notify({
        title: "Başarılı",
        text: "Parti No oluşturuldu.",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
        position: "top-center",
      });
    },
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    addItem(index) {
      const vs = this.$vs;
      if (
        this.stokIdSecilen == "" ||
        typeof this.stokIdSecilen == "undefined"
      ) {
        vs.notify({
          title: "Stok",
          text: "Stok değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else if (
        this.items[index].partino == "" ||
        typeof this.items[index].partino == "undefined"
      ) {
        vs.notify({
          title: "Parti No",
          text: "Parti No giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else if (
        this.items[index].miktar1 == "" ||
        typeof this.items[index].miktar1 == "undefined"
      ) {
        vs.notify({
          title: "Miktar1",
          text: "Miktar1 tipi giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        /*
        items: [
        {
          id: 1,
          querystok: "",
          query: "",
          stokbirim: "",
          partino: "",
          miktar1: "",
          miktar2: "",
          disable: false,
          fiyat: "",
        },
      ], */
        this.itemsIndex = index + 1;
        this.items[index].disable = true;
        this.items[index].query = this.stokIdSecilen;
        this.items[index].querystok = this.stokNameSecilen;
        this.partino = "";
        this.repeateAgain();
      }
    },
    removeItem(index) {
      this.itemsIndex -= 1;
      this.items.splice(index, 1);
    },
    repeateAgain() {
      const vs = this.$vs;
      var itemLocate = this.items[this.items.length - 1];

      if (typeof this.itemLocate == "undefined") {
        if (this.items.length == 0) {
          var eklenecekId = (this.nextTodoId += this.nextTodoId);
          this.items.push({
            id: eklenecekId,
            disable: false,
            partinoDisabled: false,
            miktar1Disabled: false,
            miktar2Disabled: false,
          });
        } else {
          var itemLocate1 = this.items[this.items.length - 1];
          if (itemLocate1.disable == false) {
            this.ekleButonDisable = true;
            vs.notify({
              title: "Uyarı",
              text: "Boşta alan bulunuyor. Öncelikle onu doldurunuz.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          } else {
            var eklenecekId = (this.nextTodoId += this.nextTodoId);
            this.items.push({
              id: eklenecekId,
              disable: false,
              partinoDisabled: false,
              miktar1Disabled: false,
              miktar2Disabled: false,
            });
          }
        }
      } else {
        if (itemLocate.disable == false) {
          this.ekleButonDisable = true;
          vs.notify({
            title: "Uyarı",
            text: "Boşta alan bulunuyor. Öncelikle onu doldurunuz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        } else {
          var eklenecekId = (this.nextTodoId += this.nextTodoId);

          this.items.push({
            id: eklenecekId,
            disable: false,
            partinoDisabled: false,
            miktar1Disabled: false,
            miktar2Disabled: false,
          });
        }
      }
    },

    getSuggestionValue(suggestion) {
      this.stokList = [];
      this.ACTNAME = suggestion.item.ACTNAME;
      this.ACTID = suggestion.item.ACTID;
      return suggestion.item.ACTNAME;
    },
    getSuggestionValuestok(suggestion) {
      this.stokIdSecilen = suggestion.item.STOCKID;
      this.stokNameSecilen = suggestion.item.STOCKNAME;
      console.log(this.itemsIndex);
      if (typeof this.items[this.itemsIndex] != "udefined")
        this.items[this.itemsIndex].stokbirim = suggestion.item.BIRIM;

      this.isDisabled = false;
      return suggestion.item.STOCKNO + " / " + suggestion.item.STOCKNAME;
    },
    onInputChange(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ISLEM: "LIST",
        ARANAN: text,
        STATUS: "2",

        //ACT için
        ACTID: "",
        ACTNO: "",
        ACTNAME: "",
        GROUPCODE: "",
        DESCRIPTION: "",
        CONTACTNAME: "",
        GSM: "",
        EMAIL: "",
        WEB: "",
        ADDRESS1: "",
        ADDRESS2: "",
        ADDRESS3: "",
        TOWN: "",
        CITY: "",
        COUNTRY: "",
        TAXOFFICE: "",
        TAXNO: "",
        TCNO: "",
        INSERTUSERID: "",
        EDITUSERID: "",
      };
      soap.createClient(url, function (err, client) {
        client.UZM_ACTLIST(args, function (err, result) {
          if (result.UZM_ACTLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.UZM_ACTLISTResult);
          vm.datasuggest = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptions = [
            {
              data: vm.datasuggest.filter((option) => {
                return (
                  option.ACTNAME.toLowerCase().indexOf(vm.query.toLowerCase()) >
                  -1
                );
              }),
            },
          ];
        });
      });
    },
    onInputChangestok(text) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        ISLEM: "LIST",
        ARANAN: text,
        STATUS: "2",

        STOCKID: "",
        STOCKNO: "",
        BARKOD: "",
        STOCKNAME: "",
        GROUPCODE: "",
        BIRIM: "",
        DESCRIPTION: "",
        INSERTUSERID: "",
        EDITUSERID: "",
      };
      soap.createClient(url, function (err, client) {
        client.UZM_STOCKLIST(args, function (err, result) {
          if (result.UZM_STOCKLISTResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.UZM_STOCKLISTResult);
          vm.datasuggeststok = vm.veriler;

          if (text === "" || text === undefined) {
            vm.isDisabled = true;
            return;
          }
          vm.filteredOptionsstok = [
            {
              data: vm.datasuggeststok.filter((option) => {
                return (
                  option.STOCKNAME.toLowerCase().indexOf(
                    vm.querystok.toLowerCase()
                  ) > -1 ||
                  option.STOCKNO.toLowerCase().indexOf(
                    vm.querystok.toLowerCase()
                  ) > -1
                );
              }),
            },
          ];
        });
      });
    },
    islemiTamamla() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      console.log(vm.$route.query.fisId);
      if (vm.fisNo != "") vm.adresKontrolDurum == true;
      console.log(vm.adresKontrolDurum);
      if (vm.items[0].query == "" || vm.adresKontrolDurum == false) {
        vs.notify({
          title: "Eksik Bilgiler",
          text: "Detay Bilgileri veya Stok Seçimi Eksik.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
      } else {
        if (vm.fisNo == "") {
          const args = {
            COMPANYID: "",
            RECEIPTID: vm.fisNo,
            TRANSTYPE: "",
            RECEIPTNO: vm.fisNo,
            DOCUMENTNO: "",
            TRANSDATE: vm.istenenTarih,
            GROUPCODE: "",
            SPECCODE1: "",
            SPECCODE2: "",
            ORDERSNO: "",
            STATUS: "",
            NOTES: "",
            DESCRIPTION: vm.textareaNot,
            TOTAL: 0.0,
            CURRCODE: "",
            CURREXC: 0.0,
            CURRTOTAL: 0.0,
            DUEDATE: "",
            PRODUCTSUM: 0.0,
            DISCOUNTSUM: 0.0,
            VATSUM: 0.0,
            ACTID: vm.ACTID,
            EGUID: "",
            INVNAME: vm.INVNAME,
            INVADRES: vm.INVADRES,
            INVTOWN: vm.INVTOWN,
            INVCITY: vm.INVCITY,
            INVCOUNTRY: vm.INVCOUNTRY,
            INVTAXTCNO: vm.INVTAXTCNO,
            INVTAXOFFICE: vm.INVTAXOFFICE,
            INVEMAIL: vm.INVEMAIL,
            INVGSM: vm.INVGSM,
            SENDNAME: vm.SENDNAME,
            SENDADRES: vm.SENDADRES,
            SENDTOWN: vm.SENDTOWN,
            SENDCITY: vm.SENDCITY,
            SENDCOUNTRY: vm.SENDCOUNTRY,
            SENDTAXTCNO: vm.SENDTAXTCNO,
            SENDTAXOFFICE: vm.SENDTAXOFFICE,
            SENDEMAIL: vm.SENDEMAIL,
            SENDGSM: vm.SENDGSM,
            INSERTUSER: vm.INSERTUSER,
            CARGOPROVIDERNAME: vm.CARGOPROVIDERNAME,
            CARGOTRACKINGNUMBER: vm.CARGOTRACKINGNUMBER,
          }; /*
        soap.createClient(url, function (err, client) {
          client.UZM_INVOICEINS(args, function (err, result) {
            if (result.UZM_INVOICEINSResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              console.log(result);
            } catch (error) {
              console.log(error);
            }
          });
        });*/
        }

        vm.items.forEach((val, ind) => {
          if (typeof this.$route.query.fisId == "undefined") {
            const args = {
              token: Store.state.tokenId,
              COMPANYID: "",
              RECEIPTID: "",
              ITEMNO: "",
              STOCKID: "",
              STOCKNO: "",
              BARCODE: "",
              DESCRIPTION: "",
              DISCOUNT1: "",
              VAT: "",
              VATINOUT: "",
              VATTOTAL: "",
              DISCOUNTTOTAL: "",
              INSERTUSER: "",
            };
            soap.createClient(url, function (err, client) {
              client.UZM_INVOICEITEMINS(args, function (err, result) {
                if (result.UZM_INVOICEITEMINSResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.items = [];
                  vm.itemsIndex = 0;
                  vm.getSTOCKTRANSDETAY(vm.guidid);
                  vm.getSTOCKTRANSBASLIK(vm.guidid);
                  vm.repeateAgain();
                } catch (error) {
                  console.log(error);
                }
              });
            });
          } else {
            const args = {
              token: Store.state.tokenId,
              COMPANYID: "",
              RECEIPTID: "",
              ITEMNO: "",
              STOCKID: "",
              STOCKNO: "",
              BARCODE: "",
              DESCRIPTION: "",
              DISCOUNT1: "",
              VAT: "",
              VATINOUT: "",
              VATTOTAL: "",
              DISCOUNTTOTAL: "",
              INSERTUSER: "",
            };
            soap.createClient(url, function (err, client) {
              client.UZM_INVOICEITEMINS(args, function (err, result) {
                if (result.UZM_INVOICEITEMINSResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.items = [];
                  vm.itemsIndex = 0;
                  vm.getSTOCKTRANSBASLIK(vm.guidid);
                  vm.getSTOCKTRANSDETAY(vm.guidid);
                  vm.repeateAgain();
                } catch (error) {
                  console.log(error);
                }
              });
            });
          }
        });
      }
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getSTOCKTRANSDETAY(gelen) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var deger = "";
      if (vm.fisNo != "") deger = vm.fisNo;
      else deger = gelen;
      const args = {
        token: Store.state.tokenId,
        FISID: deger,
      };
      /*  soap.createClient(url, function (err, client) {
        client.STOCKTRANSDETAY(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.STOCKTRANSDETAYResult);
            //  vm.rowData = vm.veriler;
            vm.rowData = vm.veriler;
            if (vm.veriler.length > 0) {
              vm.genelDisabled = true;
            }
          } catch (error) {
            console.log(error);
          }
        });
      });*/
    },
    getSTOCKTRANSBASLIK(gelen) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var deger = "";
      if (vm.fisNo != "") deger = vm.fisNo;
      else deger = gelen;
      const args = {
        token: Store.state.tokenId,
        FISID: deger,
      };
      /*   soap.createClient(url, function (err, client) {
        client.STOCKTRANSBASLIK(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.STOCKTRANSBASLIKResult);
            console.log(vm.veriler)
          } catch (error) {
            console.log(error);
          }
        });
      });*/
    },
  },

  created() {
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.stokList = [];
    if (typeof this.$route.query.fisId == "undefined") {
      this.degerKontrol = false;
    } else {
      this.degerKontrol = true;
      this.gelenFis = this.$route.query.fisId;
      this.fisNo = this.$route.query.fisId.FISID;
      this.query = this.$route.query.fisId.ACTNAME;
      this.$store.commit(
        "account/SATINALMA_CARI",
        this.$route.query.fisId.ACTNAME
      );
      this.ACTID = this.$route.query.fisId.ACTID;
      this.grupkodSecilen = this.$route.query.fisId.GROUPCODE;
      this.teslimAlan = this.$route.query.fisId.TESLIMALAN;
      this.istenenTarih = this.$route.query.fisId.TARIH;
      this.textareaNot = this.$route.query.fisId.BASLIKACIKLAMA;
    }
    this.getSTOCKTRANSBASLIK();
    this.getSTOCKTRANSDETAY();
    /*var vm = this;
    this.$watch(
      "items",
      function (after, before) {
        after.filter(function (p, idx) {

          return Object.keys(p).some(function (prop) {
          //  parseInt(prop);

           
            console.log(idx)

            var diff = p[prop] !== vm.cloneQuestions[idx][prop];

                if (diff) {
              p.changed = true;
              vm.cloneQuestions[idx][prop] = p[prop];
            }
          });

        });
      },
      { deep: true }
    );*/
  },
  mounted() {
    this.cloneQuestions = this.items.map((a) => Object.assign({}, a));
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "SatinalmaPageButon",
      },

      {
        headerName: "İşlem Tipi",
        field: "ISLEMTIPI",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Stok No",
        field: "STOCKNO",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Barkod",
        field: "BARKOD",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Grup Kodu",
        field: "GROUPCODE",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Birim",
        field: "GROUPCODE",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Parti No",
        field: "PARTINO",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Birim Ağırlık",
        field: "GROUPCODE",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Miktar1",
        field: "MIKTAR1",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Miktar2",
        field: "MIKTAR2",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Fiyat",
        field: "FIYAT",
        filter: "agTextColumnFilter",
      },
    ];
  },
};
</script>
<style lang="scss">
#autosuggest__input {
  outline: none;
  position: relative;
  display: block;
  width: 100%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

#autosuggest__input.autosuggest__input-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}
[dir] .autosuggest__results .autosuggest__results-item {
  padding: 7px !important;
}
[dir] .card-text:last-child {
  color: black;
  font-weight: 500;
}
.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 200px;
  min-height: 100px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results-before {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results
  .autosuggest__results-item.autosuggest__results-item--highlighted {
  background-color: #f6f6f6;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
[dir] .input-group-text {
  padding: 0px;
}
[dir] .vue-form-wizard .wizard-header {
  padding: 0px !important;
}
</style>